function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  margin: 0;\n\n  .select__dropdown-indicator {\n    color: black;\n  }\n\n  .select__value-container {\n    padding: 6px 8px;\n  }\n\n  .select__multi-value {\n    background: rgba(230, 242, 255, 1);\n    font-weight: 500;\n    padding: 7px;\n    border-radius: 5px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import styled from 'styled-components';
import ReactSelect from 'react-select';
export var StyledReactSelect = styled(ReactSelect)(_templateObject());
